<template>
    <div class="orderManagementClass">
        <div class="orderManagementContent" :style="contentViewHeight">
            <div class="printOrderListBox">
                <div>
                    <div class="orderSearchBox">
                        <div class="timeSearch">
                            <span style="color: #b2b2b2;">投诉时间</span>
                            <el-date-picker
                                v-model="complainDateValue"
                                @change="chooseDate"
                                value-format="yyyy-MM-dd"
                                type="daterange"
                                range-separator="—"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期">
                            </el-date-picker>
                        </div>

                        <el-input v-model="orderNo" placeholder="订单编号"></el-input>
                        <el-select v-model="status" placeholder="状态">
                            <el-option label="待处理" value="AUDIT"></el-option>
                            <el-option label="已处理" value="PASS"></el-option>
                            <el-option label="已取消" value="CANCEL"></el-option>
                        </el-select>
                        <el-input v-model="creator" placeholder="买家名称"></el-input>
                        <el-input v-model="defendant" placeholder="卖家名称"></el-input>
                        <el-select v-model="orderType" placeholder="订单类型">
                            <el-option label="打印" value="PRINT"></el-option>
                            <el-option label="商城" value="SHOP"></el-option>
                            <el-option label="设计" value="DESIGN"></el-option>
                            <el-option label="模型" value="MODEL"></el-option>
                            <el-option label="服务" value="SERVICE"></el-option>
                            <el-option label="软件" value="SOFTWARE"></el-option>
                        </el-select>
                        <el-button class="searchBtn" @click="search">搜索</el-button>
                        <el-button type="text" class="resetBtn" @click="resetData">
                            <i class="iconfont icon-qingchushujuku"></i>
                            <span>清除条件</span>
                        </el-button>
                    </div>
                    <div class="orderListTable">
                        <el-table
                            :data="tableData"
                            border
                            style="width: 100%"
                            class="tableContent"
                        >
                            <el-table-column
                                prop="orderNo"
                                label="订单编号"
                                header-align="center"
                                show-overflow-tooltip
                                align="center"
                            >
                            </el-table-column>
                            <el-table-column
                                prop="orderTotalPrice"
                                label="订单金额"
                                header-align="center"
                                align="center"
                                show-overflow-tooltip
                            >
                            </el-table-column>
                            <el-table-column
                                prop="orderCreateTime"
                                label="下单时间"
                                header-align="center"
                                show-overflow-tooltip
                                align="center"
                            >
                            </el-table-column>
                            <el-table-column
                                prop="creator"
                                label="买家名称"
                                header-align="center"
                                show-overflow-tooltip
                                align="center"
                            >
                            </el-table-column>
                            <el-table-column
                                prop="defendant"
                                label="卖家名称"
                                header-align="center"
                                show-overflow-tooltip
                                align="center"
                            >
                            </el-table-column>
                            <el-table-column
                                prop="statusCn"
                                align="center"
                                header-align="center"
                                label="状态"
                            >
                            </el-table-column>
                            <el-table-column
                                prop="auditTime"
                                align="center"
                                header-align="center"
                                label="处理时间"
                                show-overflow-tooltip
                            >
                            </el-table-column>
                            <el-table-column
                                prop="createTime"
                                align="center"
                                header-align="center"
                                label="投诉时间"
                                show-overflow-tooltip
                            >
                            </el-table-column>
                            <el-table-column
                                prop="orderTypeCn"
                                align="center"
                                header-align="center"
                                label="订单类型"
                            >
                            </el-table-column>
                            <el-table-column
                                label="操作"
                                header-align="center"
                                align="center"
                                width="230"
                            >
                                <template slot-scope="scope">
                                    <!--                  <el-button
                                                        type="text"
                                                        size="small"
                                                        v-if="scope.row.status === '待处理'"
                                                        @click="toDialog(0)"
                                                        >关闭投诉</el-button
                                                      >-->
                                    <el-button type="text" size="small" @click="toDialog(scope.row)"
                                    >{{ scope.row.status === 'AUDIT' ? '处理投诉' : '查看详情' }}
                                    </el-button
                                    >
                                    <el-button type="text" size="small" @click="gotoOrderDetail(scope.row.orderType,scope.row.orderUuid)">查看订单详情</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                        <el-pagination
                            background
                            @current-change="handleCurrentChange"
                            @prev-click="handleCurrentChange"
                            @next-click="handleCurrentChange"
                            layout="total,prev, pager, next,jumper"
                            :current-page="current"
                            :page-size="pageSize"
                            :total="total"
                            class="pagination"
                        >
                        </el-pagination>
                    </div>
                </div>
            </div>
        </div>

        <!--审核查看弹出框-->
        <el-dialog
            :title="title"
            :visible.sync="dialogVisible"
            :close-on-click-modal="false"
            width="800px"
        >
            <div class="dialogBox">
                <div class="details">
                    <div class="detailsItem">
                        <h3>订单信息</h3>
                        <div class="itemContent">
                            <div class="one-row">
                                <div class="label">订单编号：</div>
                                <div class="name">{{ complaintMess.orderNo }}</div>
                            </div>
                            <div class="one-row">
                                <div class="label">下单时间：</div>
                                <div class="name">{{ complaintMess.orderCreateTime }}</div>
                            </div>
                            <div class="two-row">
                                <div class="label">订单金额：</div>
                                <div class="name">
                                    {{ complaintMess.orderTotalPrice }}
                                </div>
                            </div>
                            <div class="two-row">
                                <div class="label">卖家名称：</div>
                                <div
                                    class="name"
                                >
                                    {{ complaintMess.sellerName }}
                                </div>
                            </div>
                            <div class="two-row">
                                <div class="label">买家名称：:</div>
                                <div class="name">
                                    {{ complaintMess.buyerName }}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="detailsItem">
                        <h3>投诉详情</h3>
                        <div class="itemContent">
                            <div class="one-row">
                                <div class="label">投诉时间：</div>
                                <div class="name">{{complaintMess.times}}</div>
                            </div>
                            <div class="two-row">
                                <div class="label">投诉内容：</div>
                                <div class="name">
                                    {{complaintMess.reason}}
                                </div>
                            </div>
                            <div class="two-row">
                                <span>投诉凭证：</span>
                                <el-image
                                    v-for="(img,index) in complaintMess.imgs"
                                    :key="index"
                                    style="width: 100px; height: 100px"
                                    :src="img"
                                    :preview-src-list="complaintMess.imgs">
                                </el-image>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="audit">
                    <h3>处理反馈（平台填写）</h3>
                    <div class="auditContent">
                        <div class="cause"  v-if="complaintMess.status !== 'AUDIT'">
                            <div class="causeContent">
                                {{ complaintMess.auditReason }}
                            </div>
                        </div>
                        <div class="cause" v-else>
                            <el-input type="textarea" v-model="auditReason" style="width:600px"></el-input>
                            <div class="causeTitle">
                                <el-button type="primary" @click="audit"
                                >提交意见
                                </el-button
                                >
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import {mapState, mapMutations} from "vuex";
import {getBackComplainList, dealComplain} from "../../utils/interface";

export default {
    components: {},
    data() {
        return {
            auditReason: '',
            form: {},
            auditForm: {},
            orderNo: "",
            status: "",
            creator: "",
            defendant: "",
            orderType: "",
            provinceOptions: this.provinceData,
            tableData: [],
            current: 1,
            pageSize: 10,
            total: 0,
            dialogVisible: false,
            title: "",
            // 投诉详情
            complaintMess: {
                uuid: '',
                orderNo: '79732985472399',
                orderCreateTime: '',
                orderTotalPrice: '',
                sellerName: '',
                buyerName: '',
                reason:'投诉原因',
                imgs:'',
                times:'021-10-09',
                auditReason: '',
                stauts: ''
            },
            complainDateValue: null,
            startTime:"",
            endTime:""
        };
    },
    computed: {
        contentViewHeight() {
            let height = document.documentElement.clientHeight - 120;
            return {minHeight: height + "px"};
        },
    },
    created() {
        this.search();
    },
    methods: {
        // 搜索
        search() {
            let params = {
                orderNo: this.orderNo,
                status: this.status,
                creator: this.creator,
                defendant: this.defendant,
                orderType: this.orderType,
                startDate:this.startTime,
                endDate:this.endTime,
                current: this.current,
                pageSize: this.pageSize,
            };
            getBackComplainList(params).then((res) => {
                this.current = res.current;
                this.total = res.total;
                this.tableData = res.list;
            });
        },
        resetData() {
            this.complainDateValue = null;
            this.orderNo = "";
            this.status = "";
            this.creator = "";
            this.defendant = "";
            this.orderType = "";
            this.startTime = "";
            this.endTime = "";
            this.search();
        },
        // 分页
        handleCurrentChange(val) {
            this.current = val;
            this.search();
        },
        // 审核查看
        toDialog(item) {
            this.complaintMess.uuid = item.uuid;
            this.complaintMess.reason = item.complainContent;
            this.complaintMess.orderNo = item.orderNo;
            this.complaintMess.buyerName = item.creator;
            this.complaintMess.sellerName = item.defendant;
            this.complaintMess.times = item.createTime;
            if(item.complainImg && item.complainImg.length > 0) {
                this.complaintMess.imgs = item.complainImg.split(",");
            }
            this.complaintMess.orderCreateTime = item.orderCreateTime;
            this.complaintMess.orderTotalPrice = item.orderTotalPrice;
            this.complaintMess.status = item.status;
            this.complaintMess.auditReason = item.auditReason;
            this.dialogVisible = true;
            this.title = "查看";
        },
        audit() {
            if(this.auditReason === '') {
                this.$message.warning("请填写意见！");
            } else {
                let params = {uuid:this.complaintMess.uuid, auditReason: this.auditReason };
                dealComplain(params).then((response) => {
                    if (response.success) {
                        this.$message({
                            type: "success",
                            message: "处理成功",
                            duration:1200,　　//显示时间, 毫秒。设为 0 则不会自动关闭，建议1200
                            onClose:()=>{
                                //跳转页面或执行方法
                                this.$router.go(0);
                            }
                        });
                    } else {
                        this.$message({
                            type: "error",
                            message: response.message,
                        });
                    }
                });
            }
        },

        gotoOrderDetail(orderType, orderUuid) {
            if(orderType === 'PRINT') {
                this.$router.push({name:'printOrderDetails',params:{uuid:orderUuid}});
            }
            else if(orderType === 'SERVICE') {
                this.$router.push({name:'serverOrderDetails',params:{uuid:orderUuid}});
            }
            else if(orderType === 'SHOP') {
                this.$router.push({name: 'mallOrDetails', params: {orderBaseUuid: orderUuid}});
            }
            else if(orderType === 'DESIGN') {
                this.$router.push({name:'designOrderDetail',params:{uuid:orderUuid}});
            }
            else if(orderType === 'MODEL') {
                this.$router.push({
                    path: '/modelOrderDetails',
                    query: {
                        uuid: orderUuid
                    }
                })
            }
        },

        // 时间格式
        chooseDate(){
            this.startTime = "";
            this.endTime = "";
            // 判断时间
            if(this.complainDateValue!=null && this.complainDateValue.length==2){
                this.startTime = this.timeDate(this.complainDateValue[0]);
                this.endTime = this.timeDate(this.complainDateValue[1]);
            }
        },
        timeDate(value){
            let date = new Date(value);
            let y = date.getFullYear();
            let MM = date.getMonth() + 1;
            MM = MM < 10 ? "0" + MM : MM;
            let d = date.getDate();
            d = d < 10 ? "0" + d : d;
            return y + "-" + MM + "-" + d;
        },
    },
};
</script>

<style scoped lang="less">
.orderManagementClass {
    position: relative;
    width: 100%;
    padding: 0 20px 20px;

    .orderManagementContent {
        background: #fff;

        .printOrderListBox {
            padding: 20px;

            .orderSearchBox {
                .timeSearch {
                    background-color: #f2f4f7;
                    height: 35px;
                    display: flex;
                    align-items: center;
                    margin-bottom: 22px;
                    margin-right: 30px;
                    border-radius: 8px;

                    span {
                        font-size: 12px;
                        color: #c0c4cc !important;
                        font-weight: normal;
                        padding-left: 15px;
                        margin-right: 5px;
                    }

                    // /deep/ .el-range-input{
                    //         background-color: #f2f4f7;
                    //             &:hover, &:focus {
                    //             background-color: #fff;
                    //             // border: 1px solid #108EE9;
                    //         }
                    // }
                    /deep/ input::-webkit-input-placeholder {
                        color: #c0c4cc;
                        font-size: 12px;
                    }

                    /deep/ .el-range-input:hover {
                        background-color: #fff !important;
                    }

                    /deep/ .el-date-editor .el-range-separator {
                        line-height: 25px;
                        color: #c0c4cc;
                    }

                    /deep/ .el-date-editor .el-range__close-icon {
                        line-height: 28px;
                    }

                    /deep/ .el-input__inner:hover .el-range-input, /deep/ .el-input__inner:focus .el-range-input {
                        background-color: white;
                    }

                    /deep/ .el-input__inner {
                        width: 225px;
                        height: 35px;
                        min-height: 35px;
                        font-size: 12px;
                        color: #999999;
                        background-color: #f2f4f7;
                        border: 1px solid #f2f4f7;
                        border-radius: 5px;

                        .el-range-input {
                            background-color: #f2f4f7;
                        }

                        &:hover, &:focus {
                            background-color: #fff;
                            border: 1px solid #108EE9;

                        }
                    }
                }
                display: flex;
                flex-wrap: wrap;

                /deep/ .el-input {
                    width: initial;
                    margin-bottom: 22px;
                    margin-right: 30px;
                }

                /deep/ .el-input__inner {
                    width: 242px;
                    height: 35px;
                    min-height: 35px;
                    font-size: 12px;
                    color: #999999;
                    background-color: #f2f4f7;
                    border: 1px solid #f2f4f7;
                    border-radius: 5px;

                    &:hover, &:focus {
                        background-color: #fff;
                        border: 1px solid #108EE9;
                    }
                }

                /deep/ .el-input__prefix {
                    top: -3px;
                }

                /deep/ .el-input__suffix {
                    top: 2px;
                }

                /deep/ .el-button {
                    display: block;
                    line-height: 35px;
                    padding: 0;
                    height: 35px;
                }

                .searchBtn {
                    width: 82px;
                    background: #3d7fff;
                    border: none;
                    border-radius: 15px;
                    font-size: 14px;
                    color: #FFFFFF;
                    margin-bottom:22px;
                }

                .resetBtn {
                    color: #333333;
                    margin-bottom:22px;
                }
            }

            .tableContent {
                min-height: 600px;

                /deep/ .el-table__header {
                    tr {
                        th {
                            border-right: none;
                        }
                    }

                    /deep/ .el-table__cell {
                        padding: 5px 0;
                        background: #f2f5fc;
                    }
                }

                /deep/ .el-table__body {
                    img {
                        vertical-align: middle;
                        width: 52px;
                        height: 50px;
                    }
                }
            }

            .pagination {
                margin-top: 20px;
                text-align: right;
            }
        }
    }
/deep/.el-dialog__header{
    border-bottom: 1px solid #ddd;
   .el-dialog__title{
    color: #000;
    font-weight: 700;
    font-size: 16px;

  }
}


    .dialogBox {
        .details {
            .detailsItem {
                padding-bottom: 20px;

                h3 {
                    font-weight: 700;
                    font-size: 16px;
                    color: #000;
                    margin-top: 0;
                    letter-spacing: 1px;
                    // border-bottom: 1px solid #ddd;
                    padding-bottom: 15px;
                }

                .itemContent {
                    display: flex;
                    flex-wrap: wrap;
                    font-size: 15px;
                    // padding: 0 30px;

                    .one-row {
                        width: 50%;
                        margin-bottom: 22px;
                        display: flex;
                        font-size: 14px;
                        .label {
                            padding-right: 15px;
                            min-width: 95px;
                            color: rgba(0, 0, 0, 0.85);
                        }

                        .name {
                            // color: #000;
                            color: rgba(0, 0, 0, 0.65);
                        }
                    }

                    .two-row {
                        // width: 100%;
                        width: 50%;
                        margin-bottom: 22px;
                        display: flex;
                        font-size: 14px;

                        .label {
                            padding-right: 15px;
                            min-width: 95px;
                            color: rgba(0, 0, 0, 0.85);
                        }

                        .name {
                            // color: #000;
                             color: rgba(0, 0, 0, 0.65);
                        }
                    }
                }

                .itemPictureContent {
                    display: flex;
                    flex-wrap: wrap;
                    font-size: 15px;
                    padding: 0 30px;
                    justify-content: space-between;

                    .one-row {
                        width: 30%;
                        margin-bottom: 22px;

                        img {
                            width: 100%;
                            height: 138px;
                            border: 1px solid #ddd;
                        }

                        .name {
                            text-align: center;
                            padding-top: 10px;
                            font-size: 14px;
                            display: flex;

                            .label {
                                min-width: 80px;
                            }
                        }
                    }
                }
            }
        }

        .audit {
            padding-bottom: 20px;

            h3 {
                font-weight: 700;
                font-size: 16px;
                color: #000;
                margin-top: 0;
                letter-spacing: 1px;
                // border-bottom: 1px solid #ddd;
                padding-bottom: 15px;
            }

            .auditContent {
                // padding: 0 30px;
            }

            .cause {
                display: flex;
                margin-top: 20px;
                align-items: center;

                .causeTitle {
                    min-width: 80px;
                    color: #3a8ee6;
                    margin-left: 20px;
                }

                .causeContent {
                    color: #000;
                }
            }

            .auditEnter {
                text-align: center;
                padding-top: 20px;

                button {
                    width: 120px;
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/complaints/complaintManagement.vue